
<template lang="pug">
  div.search
    RefineSearch(:keywords="keywords",
                 :category="category",
                 :filter="filter",
                 :selectCategory="selectCategory",
                 :selectFilter="selectFilter",
                 :toggleCategoryOptionFold="toggleCategoryOptionFold",
                 :toggleFilterOptionFold="toggleFilterOptionFold")
    SearchResult
</template>
<script>
import SearchResult from '@/components/Search/SearchResult.vue'
import RefineSearch from '@/components/Search/RefineSearch.vue'
export default {
  name: 'Search',
  data () {
    return {
      keywords: '',
      category: {
        name: 'Category',
        type: 'list',
        value: [{
          value: 'Men'
        }, {
          value: 'Kids'
        }],
        fold: false
      },
      filter: [
        {
          name: 'Size',
          type: 'size',
          value: [
            {
              value: 'L'
            },
            {
              value: 'M'
            }
          ],
          fold: true
        },
        {
          name: 'Height',
          type: 'checkbox',
          value: [
            {
              value: 'crew'
            }
          ],
          fold: true
        },
        {
          name: 'Pattern',
          type: 'checkbox',
          value: [
            {
              value: 'solid'
            }
          ],
          fold: true
        },
        {
          name: 'Fiber',
          type: 'checkbox',
          value: [
            {
              value: 'cotton'
            }
          ],
          fold: true
        },
        {
          name: 'Color',
          type: 'color',
          value: [
            {
              value: '#26ade4'
            },
            {
              value: '#fff'
            }
          ],
          fold: true
        }
      ],
      selectedCatetory: null,
      selectedFilter: null
    }
  },
  created () {
    this.keywords = this.$route.params.keywords
  },
  methods: {
    selectCategory (category) {
      this.selectedCatetory = category
    },
    selectFilter (filter, value) {
      this.selectedFilter[filter] = value
    },
    toggleCategoryOptionFold () {
      let category = { ...this.category, fold: !this.category.fold }
      this.category = category
    },
    toggleFilterOptionFold (filter) {
      this.filter = this.filter.map(item => {
        if (item.name === filter.name) {
          return { ...item, fold: !item.fold }
        }
        return item
      })
    }
  },
  components: {
    SearchResult,
    RefineSearch
  }
}
</script>
<style lang="scss" scoped>

</style>
